import { Dispatch } from 'react';
import { TMaintenancePackageActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_MAINTENANCE_PACKAGE } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { TAPIOptions } from 'src/constants/apis/types';

export const getMaintenancePackageById = async (
    dispatch: Dispatch<TMaintenancePackageActionTypes>,
    maintenancePackageId: string,
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
    }
) => {
    dispatch({ type: SET_LOADING });
    const { select, populate } = options;

    try {
        const res = await ApiV2.post(
            `/maintenance-packages/${maintenancePackageId}/read`,
            { select, populate },
            HEADERS({
                isReadPermissionNecessary:
                    options.isReadPermissionNecessary || false,
            })
        );

        dispatch({
            type: GET_MAINTENANCE_PACKAGE,
            payload: res.data.data,
        });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
